"use client";

import { useLingui } from "@lingui/react/macro";
import { useState } from "react";
import { AuthCardLayout } from "~/components/auth/AuthCardLayout";
import { ForgotPasswordFormContent, type ForgotPasswordFormData } from "./ForgotPasswordFormContent";

type ForgotPasswordFormProps = {
	onRequestReset: (data: ForgotPasswordFormData) => Promise<void>;
	redirectTo?: string;
};

export const ForgotPasswordForm = ({ onRequestReset, redirectTo }: ForgotPasswordFormProps) => {
	const { t } = useLingui();
	const [isSuccess, setIsSuccess] = useState(false);

	return (
		<AuthCardLayout
			title={t`Reset Your Password`}
			description={isSuccess ? undefined : t`Enter your email to receive password reset instructions`}
		>
			<ForgotPasswordFormContent
				onRequestReset={onRequestReset}
				redirectTo={redirectTo}
				onSuccessChange={setIsSuccess}
			/>
		</AuthCardLayout>
	);
};
